/**
 * Sub1 Template
 * @category testApp
 */
class EffectInfoTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     */
    static getTempl(_d={}) {
        let effectValueArray = [
            ['공격력',_d.ability.base.attackPowerValue,_d.ability.extra.attackPowerValue,_d.ability.set.attackPowerValue,0],
            ['관통',_d.ability.base.attackPierceValue,_d.ability.extra.attackPierceValue,_d.ability.set.attackPierceValue,0],
            ['명중',_d.ability.base.attackHitValue,_d.ability.extra.attackHitValue,_d.ability.set.attackHitValue,0],
            ['치명타',_d.ability.base.attackCriticalValue,_d.ability.extra.attackCriticalValue,_d.ability.set.attackCriticalValue,0],
            ['생명력',_d.ability.base.maxHp,_d.ability.extra.maxHp,_d.ability.set.maxHp,0],
            ['방어',_d.ability.base.defendPowerValue,_d.ability.extra.defendPowerValue,_d.ability.set.defendPowerValue,0],
            ['막기',_d.ability.base.defendParryValue,_d.ability.extra.defendParryValue,_d.ability.set.defendParryValue,0],
            ['회피',_d.ability.base.defendDodgeValue,_d.ability.extra.defendDodgeValue,_d.ability.set.defendDodgeValue,0],
            ['치명방어',_d.ability.base.defendCriticalValue,_d.ability.extra.defendCriticalValue,_d.ability.set.defendCriticalValue,0]
        ];

      let effectValueArray2 = [
        ['항마공격력',_d.ability.base.pveBossLevelNpcAttackPowerEquipMinAndMax,_d.ability.extra.pveBossLevelNpcAttackPowerEquipMinAndMax,_d.ability.set.pveBossLevelNpcAttackPowerEquipMinAndMax,0],
        ['항마방어력',_d.ability.base.pveBossLevelNpcDefendPowerEquipValue,_d.ability.extra.pveBossLevelNpcDefendPowerEquipValue,_d.ability.set.pveBossLevelNpcDefendPowerEquipValue,0],
        ['대인공격력',_d.ability.base.pvpAttackPowerEquipMinAndMax,_d.ability.extra.pvpAttackPowerEquipMinAndMax,_d.ability.set.pvpAttackPowerEquipMinAndMax,0],
        ['대인방어력',_d.ability.base.pvpDefendPowerEquipValue,_d.ability.extra.pvpDefendPowerEquipValue,_d.ability.set.pvpDefendPowerEquipValue,0],
        ['공력',_d.ability.base.attackAttributeValueEquip,_d.ability.extra.attackAttributeValueEquip,_d.ability.set.attackAttributeValueEquip,0],
        ['상태이상피해',_d.ability.base.abnormalAttackPowerValueEquip,_d.ability.extra.abnormalAttackPowerValueEquip,_d.ability.set.abnormalAttackPowerValueEquip,0],
        ['상태이상방어',_d.ability.base.abnormalDefendPowerValue,_d.ability.extra.abnormalDefendPowerValue,_d.ability.set.abnormalDefendPowerValue,0],
        ['회복',_d.ability.base.healPowerValue,_d.ability.extra.healPowerValue,_d.ability.set.healPowerValue,0],
        ['치명피해',_d.ability.base.attackCriticalDamageValueEquip,_d.ability.extra.attackCriticalDamageValueEquip,_d.ability.set.attackCriticalDamageValueEquip,0]
      ];
        let resultValueArray = EffectInfoTempl.intDot(effectValueArray);
        let EffectValueList = EffectInfoTempl.getEffectValueList(resultValueArray);


      let resultValueArray2 = EffectInfoTempl.intDot(effectValueArray2);
      let EffectValueList2 = EffectInfoTempl.getEffectValueList(resultValueArray2);

        return `
	      <dl class="effect-value-list">
            ${EffectValueList}
        </dl>
	      <dl class="effect-value-list">
            ${EffectValueList2}
        </dl>
        `;
    }
    static getSetTempl(_d={}){

      const EffectSetList = EffectInfoTempl.getEffectSetTempl(_d);
      return `
        <div class="character-effect-set">${EffectSetList}</div>
      `;
    }

    static intDot(_valueArray){
        let effectValueArray;
        for(let i=0;i<_valueArray.length;i++){
            _valueArray[i][4] = _valueArray[i][1] + _valueArray[i][2] + _valueArray[i][3];
            for(let j=1;j<_valueArray[i].length;j++){
                _valueArray[i][j] = _valueArray[i][j].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
        effectValueArray = _valueArray;

        return effectValueArray;
    }

    static getEffectValueList(_valueArray){
        let EffectValueList = ``;
        for(let i=0;i<_valueArray.length;i++){
            EffectValueList +=
                `<dt>${_valueArray[i][0]}</dt>
                <dd>${_valueArray[i][4]}
                (${_valueArray[i][1]}+${_valueArray[i][2]}+${_valueArray[i][3]})
                </dd>
            `;
        }

        return EffectValueList;
    }

    static getEffectSetTempl(_d){
        let EffectSetList = ``;
        let effectArray = _d.effects;
      // let effectArray = [
      //   {name:'123', equippedCount:10, actuations:[{ partCount:0, partEffects:[{skillName:'123123132', description:'description'}]}]},
      //   {name:'123', equippedCount:10, actuations:[{ partCount:0, partEffects:[{skillName:'123123123', description:'description'}]}]}
      // ]

        for(let i=0; i<effectArray.length; i++){
            EffectSetList += `<string class="effect-set-title">${effectArray[i].name}</string>`;
            let actuationsArray = effectArray[i].actuations;
            if(actuationsArray) {
                for (let j = 0; j < actuationsArray.length; j++) {
                    if (effectArray[i].equippedCount >= actuationsArray[j].partCount) {
                        EffectSetList += `<em class="effect-set-num">${actuationsArray[j].partCount}세트</em>`;
                        let partEffectsArray = actuationsArray[j].partEffects;
                        for (let k = 0; k < partEffectsArray.length; k++) {
                            EffectSetList += `<span class="effect-set-text">${partEffectsArray[k].skillName ? partEffectsArray[k].skillName : ''} ${partEffectsArray[k].description}</span>`;
                        }
                    }
                }
            }
        }
        return EffectSetList;
    }




} // end of class

export default EffectInfoTempl;
